import React from 'react';
import PropTypes from 'prop-types';
import css from '../Login.scss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Link } from 'panamera-react-ui';
import Button from 'Components/Button/Button';
import { FormattedMessage as Translation } from 'react-intl';
import * as configHelper from 'Helpers/config';
import withTrack from 'HOCs/withTrack/withTrack';
import { configSelector } from 'Selectors/config';

export class TermsAndConditions extends React.Component {
    static propTypes = {
        onClickAccept: PropTypes.func.isRequired,
        onClickDeny: PropTypes.func.isRequired,
        config: PropTypes.object,
        track: PropTypes.func.isRequired
    };

    static defaultProps = {
        config: {}
    };

    constructor(props) {
        super(props);

        const links = configHelper.getCountryConfig(props.config).privacy_links;

        this.values = {
            termsOfUse: <Translation id="terms_of_use" >{ msg => (<Link title={ msg } to={ links.terms_url } onClick={ this.onClickLink } data-aut-id="btnLinktyc">{ msg }</Link>)}</Translation>,
            privacyStatements: <Translation id="privacy_policy" > { msg => (<Link title={ msg } to={ links.privacy_url } onClick={ this.onClickLink } data-aut-id="btnLinkpp">{ msg }</Link>)}</Translation>,
            cookiesPolicy: <Translation id="cookies_policy" >{ msg => (<Link title={ msg } to={ links.cookies_url } onClick={ this.onClickLink } data-aut-id="btnLinkcp">{ msg }</Link>)}</Translation>
        };
    }

    onClickDeny = () => {
        this.props.onClickDeny();
        this.props.track('terms_deny');
    };

    onClickAccept = () => {
        this.props.onClickAccept();
        this.props.track('terms_agree');
    };

    onClickLink = () => {
        this.props.track('terms_view_more');
    };

    render() {
        return (
            <div className={ css.termsAndConditions }>
                <div className={ css.title }>
                    <Translation id="terms_title" />
                </div>
                <p className={ css.text }>
                    <Translation id="terms_copy" values={ this.values } />
                </p>
                <div className={ css.cta }>
                    <Button
                        type="btnMain"
                        data-aut-id="btnAccept"
                        className={ css.accept }
                        onClick={ this.onClickAccept }
                    >
                        <Translation id="terms_accept" />
                    </Button>
                </div>
                <div className={ css.cta }>
                    <span
                        className={ css.deny }
                        onClick={ this.onClickDeny }
                        data-aut-id="btnDeny"
                    >
                        <Translation id="terms_deny" />
                    </span>
                </div>
            </div>
        );
    }
}

export const mapStateToProps = state => {
    return {
        config: configSelector(state)
    };
};

export default compose(
    withTrack,
    connect(mapStateToProps)
)(TermsAndConditions);
